module.exports = __webpack_public_path__ + "img/waveform.910482fe.svg";